import { render, staticRenderFns } from "./StudentsGrid.vue?vue&type=template&id=6fa1259d"
import script from "./StudentsGrid.vue?vue&type=script&lang=js"
export * from "./StudentsGrid.vue?vue&type=script&lang=js"
import style0 from "./StudentsGrid.vue?vue&type=style&index=0&id=6fa1259d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports